import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { AlertTriangle } from "lucide-react";

export function DeleteConfirmModal({ open, onOpenChange, title, description, itemName, onConfirm, loading }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="delete-confirm-modal">
        <DialogHeader className="text-center">
          <div className="mx-auto w-12 h-12 rounded-full bg-red-500/15 flex items-center justify-center mb-3">
            <AlertTriangle className="h-6 w-6 text-red-500" />
          </div>
          <DialogTitle className="text-lg font-heading">{title || "Confirm Delete"}</DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground">
            {description || "This action cannot be undone."}
          </DialogDescription>
        </DialogHeader>
        {itemName && (
          <div className="py-4 px-4 bg-secondary/50 rounded-lg my-2">
            <p className="text-sm text-center font-medium">{itemName}</p>
          </div>
        )}
        <DialogFooter className="flex gap-2 sm:gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1" data-testid="cancel-delete-btn">
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={loading} className="flex-1" data-testid="confirm-delete-btn">
            {loading ? "Deleting..." : "Delete"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
